export { default } from './FeaturedPostCarousel';
export { default as adapter } from './adapter';
